import Box from '@mui/material/Box';
import type React from 'react';

type GroupContentProps = {
  children: React.ReactNode;
};

export const GroupContent = ({ children }: GroupContentProps) => {
  return (
    <Box
      sx={{
        p: 2,
      }}
    >
      {children}
    </Box>
  );
};
